import { defineComponent as _defineComponent } from 'vue'
import SalesFlyerNoAds from './SalesFlyerNoAds.vue';
import SalesFlyerSearchForm from './SalesFlyerSearchForm.vue';
import SalesFlyerSideMenu from './side-menu/SalesFlyerSideMenu.vue';
import SalesFlyerView from './SalesFlyerView.vue';
import { getSalesFlyerPageProductListLink, SalesFlyerProductSearch } from '../utilities/product-list';
import { onBeforeMount, ref, watchEffect } from 'vue';
import { RouterLink } from 'vue-router';
import { SalesFlyerResource } from '../types';
import { useIsMobileAppWebView } from '../composables/mobile-app-web-view';
import { useRoute, useRouter } from 'vue-router/composables';

// Notes for implementation
//
// TODO: Show product side panel when "Shop Deals" is selected on a sales flyer page
//       Nice-to-have considerations:
//       - If a user presses a link inside of the product side panel (e.g. Shop All or a product link), it might
//         be nice to restore the side panel and its scroll position if they navigate back to the page. We may consider
//         using sessionStorage to keep track of that while a side panel is open
// TODO: Consider introducing @tanstack/vue-query


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerApp',
  props: {
    activeSalesFlyers: null,
    salesFlyer: null
  },
  setup(__props: any) {

const props = __props as {
	activeSalesFlyers: SalesFlyerResource[],
	salesFlyer: SalesFlyerResource | null,
}



const router = useRouter();
const route = useRoute();

onBeforeMount(() => {
	// if we have sales flyers, but no selected flyer, then that means the
	// flyer specified by the `promo` query param is unavailable.
	// this will remove the `promo` param, which will cause the first flyer
	// to be selected.
	if (!props.salesFlyer && props.activeSalesFlyers?.length) {
		const { promo: _, ...query } = route.query;
		router.replace({
			query,
		});
	}
});

// NOTE: keep in sync with similar code in SalesFlyerController.cs
const BASE_FLYER_PAGE_TITLE = `Our Sales Flyer | Blain's Farm & Fleet`;
watchEffect(() => {
	const currentFlyerTitle = props.salesFlyer?.flyerTitle;
	if (!currentFlyerTitle || !route.query.promo) {
		document.title = BASE_FLYER_PAGE_TITLE;
	} else {
		document.title = `${currentFlyerTitle} | ${BASE_FLYER_PAGE_TITLE}`;
	}
});

function isSalesFlyerActive(flyer: SalesFlyerResource): boolean {
	return props.salesFlyer?.promoNumber === flyer.promoNumber;
}

const isMobileAppWebView = useIsMobileAppWebView();

const sidePanelSearch = ref<SalesFlyerProductSearch | null>(null);

function handleFullFlyerSearch(keyword: string) {
	keyword = keyword?.trim();
	if (!props.salesFlyer || !keyword) {
		return;
	}

	const search: SalesFlyerProductSearch = {
		promoNumber: props.salesFlyer.promoNumber,
		keyword,
	};

	if (isMobileAppWebView.value) {
		window.location.assign(getSalesFlyerPageProductListLink(search));
	} else {
		sidePanelSearch.value = search;
	}
}

return { __sfc: true,props, router, route, BASE_FLYER_PAGE_TITLE, isSalesFlyerActive, isMobileAppWebView, sidePanelSearch, handleFullFlyerSearch, SalesFlyerNoAds, SalesFlyerSearchForm, SalesFlyerSideMenu, SalesFlyerView, RouterLink }
}

})